import {
  SEGMENTS_LIST,
  SEGMENTS_LIST_SUCCESS,
  SEGMENTS_LIST_ERROR,
  SEGMENTS_NEW,
  SEGMENTS_NEW_SUCCESS,
  SEGMENTS_NEW_ERROR,
  SEGMENTS_EDIT,
  SEGMENTS_DELETE,
  SEGMENTS_DELETE_SUCCESS,
  SEGMENTS_DELETE_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseDelete: "",
  loadingDelete: false,
  errorDelete: "",
}

const Sections = (state = initialState, action) => {
  switch (action.type) {
    case SEGMENTS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case SEGMENTS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case SEGMENTS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case SEGMENTS_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case SEGMENTS_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case SEGMENTS_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case SEGMENTS_EDIT:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case SEGMENTS_DELETE:
      state = {
        ...state,
        loadingDelete: true,
        responseDelete: "",
        errorDelete: ""
      }
      break
    case SEGMENTS_DELETE_SUCCESS:
      state = {
        ...state,
        loadingDelete: false,
        responseDelete: action.payload.data
      }
      break
    case SEGMENTS_DELETE_ERROR:
      state = {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Sections
